<div class="offcanvas-header">
	<div class="left">
		<div class="status-icon" [style.background-color]="calendarEventOffcanvas.title.iconColour"></div>
		<h3 class="offcanvas-title">
			{{ calendarEventOffcanvas.title.text }}
			<div *ngIf="calendarEventOffcanvas.title.subtitle" class="header-subtitle">
				{{ calendarEventOffcanvas.title.subtitle }}
			</div>
		</h3>
	</div>
	<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<hr class="mx-3" />
<div class="offcanvas-body">
	<div class="body">
		<div class="alert-items">
			<ng-container *ngFor="let alert of calendarEventOffcanvas.alerts">
				<app-alert [content]="alert" [dismissible]="true" [alertType]="AlertTypes.SUCCESS" [marginBottom]="0"></app-alert>
			</ng-container>
		</div>
		<div class="calendar-items">
			<ng-container *ngIf="calendarEventOffcanvas.customAction as action">
				<ng-container [ngSwitch]="action.type">
					<ng-container *ngSwitchCase="CalendarCustomActionType.ASSESSMENT_STATUS_DROPDOWN">
						<ng-container *ngIf="action.visible">
							<ng-container *ngIf="action.canEdit">
								<app-assessment-status-dropdown
									[(status)]="action.value"
									(statusChange)="action.onChange($event)"
									[statusOptions]="action.meta.options"
								></app-assessment-status-dropdown>
							</ng-container>
						</ng-container>
					</ng-container>
				</ng-container>
			</ng-container>

			<ng-container *ngFor="let item of calendarEventOffcanvas.detailItems">
				<ng-container *ngIf="item.visible">
					<div class="item-detail">
						<ng-container *ngIf="item.icon as icon">
							<i class="bi icon" [ngClass]="icon"></i>
						</ng-container>

						<div class="content">
							<ng-container *ngIf="item.content as content">
								<div class="title">{{ content.title }}</div>
								<div *ngIf="content.description" class="description">{{ content.description }}</div>
								<div *ngIf="content.location" class="description">
									<app-link-location
										[property]="content.location"
										[maxCharacters]="60"
										[showIcon]="false"
									></app-link-location>
								</div>
							</ng-container>
							<ng-container *ngIf="item.action as action">
								<button type="button" class="btn btn-sm btn-primary" (click)="actionClick(action.onClick, true)">
									<ng-container *ngIf="action.icon">
										<i class="bi" [ngClass]="action.icon"></i>
									</ng-container>
									{{ action.actionText }}
								</button>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>

	<div class="footer">
		<div class="actions">
			<div class="buttons">
				<ng-container *ngFor="let button of calendarEventOffcanvas.buttons">
					<ng-container *ngIf="button.visible">
						<button
							type="button"
							class="btn btn-sm"
							[ngClass]="button.classColour"
							(click)="actionClick(button.onClick, false)"
							[disabled]="button.disabled"
						>
							<ng-container *ngIf="button.isLoading; else notLoading">
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
							</ng-container>
							<ng-template #notLoading>
								<i *ngIf="button.icon" class="bi" [ngClass]="button.icon"></i>
								{{ button.text }}
							</ng-template>
						</button>
					</ng-container>
				</ng-container>
			</div>
		</div>
	</div>
</div>
